import { useEffect, useState } from "react";

interface VersionPayload {
  version?: string;
  build?: string;
}

/** Bottom-right build stamp, fed by /api/version (child-repo standard). */
export default function VersionStamp() {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        const res = await fetch("/api/version");
        if (!res.ok) return;
        const v = (await res.json()) as VersionPayload;
        if (v.version) setText(`v${v.version}${v.build ? ` · ${v.build}` : ""}`);
      } catch {
        /* stamp is best-effort */
      }
    })();
  }, []);

  if (!text) return null;
  return (
    <div
      className="position-fixed bottom-0 end-0 pe-2 pb-1 text-muted"
      style={{ fontSize: "0.7rem", pointerEvents: "none" }}
    >
      {text}
    </div>
  );
}
